export const PersonWithIncludesDictionary = {
    Addresses: {
        'Enderecos' : {
            AddressId: 'EnderecoId',
        }
    },
};